import HelpCenter from '@/help/HelpCenter';
import { BrowserRouter, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { useAuthStore } from '@/store/authStore';

function RootRedirect() {
  const token = useAuthStore((s) => s.token);
  return token ? <Navigate to="/dashboard" replace /> : <Navigate to="/login" replace />;
}

function MonitoringFlowRedirect() {
  const location = useLocation();
  const plant = new URLSearchParams(location.search).get('plant');
  return plant ? <Navigate to={`/dashboard/powerplants/${plant}/flow`} replace /> : <Navigate to="/dashboard/powerplants" replace />;
}
import LoginPage from '@/pages/LoginPage';
import HomePage from '@/pages/HomePage';
import PowerPlantsPage from '@/pages/powerplants/PowerPlantsPage';
import PowerPlantDetailPage from '@/pages/powerplants/PowerPlantDetailPage';
import PlantHealthAnalysisPage from '@/pages/powerplants/PlantHealthAnalysisPage';
import PVGISPage from '@/pages/powerplants/PVGISPage';
import ForecastSolarPage from '@/pages/powerplants/ForecastSolarPage';
import SitesPage from '@/pages/sites/SitesPage';
import SitesListPage from '@/pages/sites/SitesListPage';
import InvertersPage from '@/pages/inverters/InvertersPage';
import InverterDetailPage from '@/pages/inverters/InverterDetailPage';
import StringDetailPage from '@/pages/inverters/StringDetailPage';
import AlarmAltPage from '@/pages/alarm/AlarmAltPage';
import AlarmAltDetailPage from '@/pages/alarm/AlarmAltDetailPage';
import MonitoringPage from '@/pages/monitoring/MonitoringPage';
import EnergyFlowPage from '@/pages/monitoring/EnergyFlowPage';
import ManagementPage from '@/pages/management/ManagementPage';
import UIPage from '@/pages/ui/UIPage';
import AutomationPage from '@/pages/automation/AutomationPage';
import AgileBoardPage from '@/pages/agile/AgileBoardPage';
import InvestorsPage from '@/pages/investor/InvestorsPage';
import InvestorDetailPage from '@/pages/investor/InvestorDetailPage';
import MaintenancePage from '@/pages/maintenance/MaintenancePage';
import MaintenanceStudioPage from '@/pages/maintenance/MaintenanceStudioPage';
import TasksPage from '@/pages/tasks/TasksPage';
import SensorsPage from '@/pages/sensor/SensorsPage';
import SensorDetailPage from '@/pages/sensor/SensorDetailPage';
import ReportsPage from '@/pages/reports/ReportsPage';
import DashboardLayout from '@/layouts/DashboardLayout';
import ProtectedRoute from '@/components/ProtectedRoute';
import { AppToaster } from '@/lib/notify';
import './index.css';

export default function App() {
  return (
    <>
      <AppToaster />
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<RootRedirect />} />
          <Route path="/login" element={<LoginPage />} />

        <Route element={<ProtectedRoute />}>
          <Route element={<DashboardLayout />}>
            <Route path="/dashboard"             element={<HomePage />} />
            <Route path="/dashboard/help" element={<HelpCenter />} />
            <Route path="/dashboard/powerplants" element={<PowerPlantsPage />} />
            <Route path="/dashboard/powerplants/:uuid_id" element={<PowerPlantDetailPage />} />
            <Route path="/dashboard/powerplants/:uuid_id/health-analysis" element={<PlantHealthAnalysisPage />} />
            <Route path="/dashboard/powerplants/:uuid_id/pvgis-analysis" element={<PVGISPage />} />
            <Route path="/dashboard/powerplants/:uuid_id/forecast-solar-analysis" element={<ForecastSolarPage />} />
            <Route path="/dashboard/sites" element={<SitesListPage />} />
            <Route path="/dashboard/sites/:uuid_id" element={<SitesPage />} />
            <Route path="/dashboard/powerplants/:uuid_id/inverters" element={<InvertersPage />} />
            <Route path="/dashboard/powerplants/:uuid_id/flow" element={<EnergyFlowPage />} />
            <Route path="/dashboard/inverters" element={<InvertersPage />} />
            <Route path="/dashboard/inverters/:id" element={<InverterDetailPage />} />
            <Route path="/dashboard/inverters/:id/string/:stringNumber" element={<StringDetailPage />} />
            <Route path="/dashboard/investor" element={<InvestorsPage />} />
            <Route path="/dashboard/investor/:uuid_id" element={<InvestorDetailPage />} />
            <Route path="/dashboard/investor/:uuid_id/detail" element={<InvestorDetailPage />} />
            <Route path="/dashboard/maintenance" element={<MaintenancePage />} />
            <Route path="/dashboard/maintenance-studio" element={<MaintenanceStudioPage />} />
            <Route path="/dashboard/alarms" element={<AlarmAltPage />} />
            <Route path="/dashboard/alarms/detail" element={<AlarmAltDetailPage />} />
            <Route path="/dashboard/tasks" element={<TasksPage />} />
            <Route path="/dashboard/tasks/board" element={<Navigate to="/dashboard/tasks" replace />} />
            <Route path="/dashboard/agile" element={<AgileBoardPage />} />
            <Route path="/dashboard/tasks/create" element={<Navigate to="/dashboard/tasks" replace />} />
            <Route path="/dashboard/tasks/:uuid_id" element={<Navigate to="/dashboard/tasks" replace />} />
            <Route path="/dashboard/sensors" element={<SensorsPage />} />
            <Route path="/dashboard/sensors/:uuid_id" element={<SensorDetailPage />} />
            <Route path="/dashboard/reports" element={<ReportsPage />} />
            <Route path="/dashboard/management" element={<ManagementPage />} />
            <Route path="/dashboard/management/users" element={<ManagementPage />} />
            <Route path="/dashboard/automation" element={<AutomationPage />} />
            <Route path="/dashboard/monitoring" element={<MonitoringPage />} />
            <Route path="/dashboard/monitoring/flow" element={<MonitoringFlowRedirect />} />
            <Route path="/dashboard/ui" element={<UIPage />} />
          </Route>
        </Route>

        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
      </BrowserRouter>
    </>
  );
}
